import { render } from "./ComHeader.vue?vue&type=template&id=68717c50&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import "./ComHeader.vue?vue&type=style&index=0&id=68717c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68717c50"]])

export default __exports__